import { Icon, IconProps } from '@chakra-ui/react';

function WalletIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.6665 13.5C17.0998 13.5 17.4582 13.3583 17.7415 13.075C18.0248 12.7917 18.1665 12.4333 18.1665 12C18.1665 11.5667 18.0248 11.2083 17.7415 10.925C17.4582 10.6417 17.0998 10.5 16.6665 10.5C16.2332 10.5 15.8748 10.6417 15.5915 10.925C15.3082 11.2083 15.1665 11.5667 15.1665 12C15.1665 12.4333 15.3082 12.7917 15.5915 13.075C15.8748 13.3583 16.2332 13.5 16.6665 13.5ZM5.6665 21C5.1165 21 4.64567 20.8042 4.254 20.4125C3.86234 20.0208 3.6665 19.55 3.6665 19V5C3.6665 4.45 3.86234 3.97917 4.254 3.5875C4.64567 3.19583 5.1165 3 5.6665 3H19.6665C20.2165 3 20.6873 3.19583 21.079 3.5875C21.4707 3.97917 21.6665 4.45 21.6665 5V7.5H19.6665V5H5.6665V19H19.6665V16.5H21.6665V19C21.6665 19.55 21.4707 20.0208 21.079 20.4125C20.6873 20.8042 20.2165 21 19.6665 21H5.6665ZM13.6665 17C13.1165 17 12.6457 16.8042 12.254 16.4125C11.8623 16.0208 11.6665 15.55 11.6665 15V9C11.6665 8.45 11.8623 7.97917 12.254 7.5875C12.6457 7.19583 13.1165 7 13.6665 7H20.6665C21.2165 7 21.6873 7.19583 22.079 7.5875C22.4707 7.97917 22.6665 8.45 22.6665 9V15C22.6665 15.55 22.4707 16.0208 22.079 16.4125C21.6873 16.8042 21.2165 17 20.6665 17H13.6665ZM20.6665 15V9H13.6665V15H20.6665Z" />
    </Icon>
  );
}

export { WalletIcon };
